/*
    © 2023 NetSuite Inc.
    User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
    provided, however, if you are an authorized user with a NetSuite account or log-in, you
    may use this code subject to the terms that govern your access and use.
*/
/* globals getExtensionAssetsPath */
define('CoreCharge.Model', [
    'Backbone',
    'Utils'
], function CoreChargeModel(
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                'Modules/Main/SuiteScript2/CoreCharge.Service.ss'
            ),
            true
        )
    });
});
